import { IUserAllInfoResponseData } from "./../setup/api/services/user/models";
import { useCallback, useEffect, useState } from "react";
import { getUserDetailsById } from "../setup/api/services/user";

const useGetUserInfo = (id) => {
  const [data, setData] = useState<IUserAllInfoResponseData | undefined>(
    undefined
  );

  const [loading, setLoading] = useState<boolean>(false);

  const fetchUserStats = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getUserDetailsById(id);
      if (response) {
        setData(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchUserStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    loading,
  };
};

export default useGetUserInfo;
